import { render, staticRenderFns } from "./ElevatorTroubleLogTable.vue?vue&type=template&id=c4a54944"
import script from "./ElevatorTroubleLogTable.vue?vue&type=script&script=true&setup=true&lang=js"
export * from "./ElevatorTroubleLogTable.vue?vue&type=script&script=true&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4a54944')) {
      api.createRecord('c4a54944', component.options)
    } else {
      api.reload('c4a54944', component.options)
    }
    module.hot.accept("./ElevatorTroubleLogTable.vue?vue&type=template&id=c4a54944", function () {
      api.rerender('c4a54944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/elevator-trouble-logs/ElevatorTroubleLogTable.vue"
export default component.exports